import { Menu } from 'antd'
import React from 'react'
import styles from '../../../components/Header/AdminHeader/AdminHeader.module.scss'
import { useUserSelector } from '@store/selectors/auth'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@store/hooks'
import { authLogout } from '@store/auth/thunk'
import { useModalContext } from '@context/modalContext'
import DropdownUI from '@components/ui/DropDownUI/DropdownUi'
import ProfileUpdateModal from '@components/Modals/ProfileUpdate/ProfileUpdate.modal'
import { routersPath } from '@router/routes-path'
import { IconClipboardCheck, IconLogOut, IconUser } from '@utils/icons'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import useCopyToClipboard from '@hooks/useClipboard'

interface MenuClickEventHandler {
  key: string
}
export const AdminProfileDrop = React.memo(() => {
  const user = useUserSelector()
  const dispatch = useAppDispatch()
  const { setModalComponent } = useModalContext()
  const navigator = useNavigate()
  const handleCopy = useCopyToClipboard()

  const getHash = async () => {
    const { data } = await axiosInstance.get(serverPath.HASH)
    handleCopy(data)
  }

  const handler = (e: MenuClickEventHandler | undefined) => {
    switch (e?.key) {
      case 'profile': {
        user &&
          setModalComponent({
            component: (
              <ProfileUpdateModal
                update={() => {
                  navigator(routersPath.LOGIN_PAGE)
                }}
              />
            ),
            maskClosable: true,
          })
        break
      }
      case 'hash': {
        getHash()
        break
      }
      case 'exit': {
        dispatch(authLogout())
        break
      }
      case 'powerOff': {
        console.log('Power OFF CRM')
        break
      }
      default:
        return
    }
  }

  const AdminProfile = (
    <Menu
      onClick={handler}
      items={[
        {
          key: 'profile',
          label: <span>Профиль</span>,
          icon: <IconUser width='20' height='20' fill='var(--color-main)' />,
        },
        {
          key: 'hash',
          label: <span>Получить хеш</span>,
          icon: <IconClipboardCheck width='20' height='20' fill='var(--color-main)' />,
        },
        {
          key: 'exit',
          label: <span>Выход</span>,
          icon: <IconLogOut width='20' height='20' fill='var(--color-main)' />,
        },
      ]}
    />
  )
  return (
    <DropdownUI menu={AdminProfile}>
      <span className={styles.backdrop}>
        <span className={styles.icon}>
          <IconUser width='22' height='22' fill='var(--color-main)' />
        </span>
        <b>{user?.nickName ?? 'Нет имени'}</b>
      </span>
    </DropdownUI>
  )
})
